import React from 'react';
import useCreateModal from 'Components/Popups/useCreateModal';
import { useAuth } from 'utils/AuthProvider';
import HomeworkModal from './HomeworkModal';
import { CheckedIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import './HomeworkButton.css';

export default function HomeworkButton() {
  const { isClient } = useAuth();
  const HomeworkPopup = useCreateModal();

  if (!isClient) return null;

  return (
    <>
      <Button
        theme="green-fill"
        className="homework-button"
        onClick={() => HomeworkPopup.open()}
        aria-label="TODO LIST"
      >
        <CheckedIcon className="w-4 h-4" />
        <span className="hidden md:inline">TODO LIST &nbsp;&nbsp;&nbsp;</span>
        <span className="md:hidden">TODO</span>
      </Button>

      <HomeworkPopup.Component>
        <HomeworkModal />
      </HomeworkPopup.Component>
    </>
  );
}
